module.exports = __webpack_public_path__ + "static/media/companyLogo.f847a406.png";